module.exports = __webpack_public_path__ + "img/liberty.89532d5b.png";